import queryString from "query-string";
import React, { useEffect } from "react";

const PostRedirection = ()=>{
    
    useEffect(()=>{
        const parsed = queryString.parse(window.location.search);
        if(parsed && Object.keys(parsed).length>0){
            const postUrl = parsed.postUrl;
            window.location.replace(postUrl);
        }
    },[])
  return <></>
}

export default PostRedirection;